import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "world-map" }
const _hoisted_2 = { class: "world-map__filters" }
const _hoisted_3 = { class: "world-map__title" }
const _hoisted_4 = { class: "world-map__right" }
const _hoisted_5 = {
  key: 0,
  class: "world-map__dropdowns",
  ref: "filtersdropdowns"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "world-map__dropdowns-title" }, " Filter by: ", -1)
const _hoisted_7 = { class: "world-map__dropdowns-search__form" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "world-map__dropdowns-checkmark" }, null, -1)
const _hoisted_9 = { class: "world-map__dropdowns-option" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "world-map__dropdowns-checkmark" }, null, -1)
const _hoisted_11 = { class: "world-map__dropdowns-option" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "world-map__dropdowns-checkmark" }, null, -1)
const _hoisted_13 = { class: "world-map__dropdowns-option" }
const _hoisted_14 = { class: "world-map__dropdowns-option" }
const _hoisted_15 = { class: "world-map-relative" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "world-map__info-box-name" }
const _hoisted_18 = { class: "world-map__info-box-description" }
const _hoisted_19 = {
  key: 0,
  class: "location-info location-info-bold"
}
const _hoisted_20 = {
  key: 1,
  class: "location-info"
}
const _hoisted_21 = {
  key: 2,
  class: "location-info"
}
const _hoisted_22 = {
  key: 3,
  class: "location-info"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 4,
  class: "location-info"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 5,
  class: "location-info"
}
const _hoisted_28 = ["href", "target"]
const _hoisted_29 = {
  key: 1,
  class: "location-info"
}
const _hoisted_30 = { class: "world-map__locations" }
const _hoisted_31 = { class: "location-info location-info-country" }
const _hoisted_32 = { class: "location-info location-info-bold" }
const _hoisted_33 = {
  key: 0,
  class: "location-info"
}
const _hoisted_34 = {
  key: 1,
  class: "location-info"
}
const _hoisted_35 = {
  key: 2,
  class: "location-info"
}
const _hoisted_36 = ["href"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 3,
  class: "location-info"
}
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "location-info location-info-country" }
const _hoisted_41 = { class: "location-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_vit_dropdown = _resolveComponent("vit-dropdown")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_google_map = _resolveComponent("google-map")!
  const _component_vit_accordion = _resolveComponent("vit-accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_icon, {
          name: "icn-search",
          class: _normalizeClass(["world-map__filter-bar-btn", {'world-map__filter-bar-btn--active': _ctx.searchVisible}]),
          onClick: _ctx.toggleSearch
        }, null, 8, ["class", "onClick"]),
        _createVNode(_component_icon, {
          name: "icn-button-filter",
          class: _normalizeClass(["world-map__filter-bar-btn", {'world-map__filter-bar-btn--active': _ctx.filtersVisible}]),
          onClick: _ctx.toggleFilters
        }, null, 8, ["class", "onClick"])
      ])
    ]),
    _createVNode(_Transition, { name: "filters__anim" }, {
      default: _withCtx(() => [
        (_ctx.filtersVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.regions.length > 1)
                ? (_openBlock(), _createBlock(_component_vit_dropdown, {
                    key: 0,
                    label: _ctx.regionLabel,
                    multiple: "",
                    light: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_dropdown_item, { class: "world-map__dropdowns-search" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon, {
                            name: "icn-search",
                            class: "world-map__dropdowns-search__icon"
                          }),
                          _createElementVNode("form", _hoisted_7, [
                            _withDirectives(_createElementVNode("input", {
                              class: "world-map__dropdowns-search__input",
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.regionSearch) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.regionSearch]
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      (!_ctx.regionSearch)
                        ? (_openBlock(), _createBlock(_component_dropdown_item, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectRegion(null))),
                            class: _normalizeClass({'world-map__dropdowns-active': _ctx.allRegions })
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8,
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.allRegionsLabel), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionSearchResults, (region) => {
                        return (_openBlock(), _createBlock(_component_dropdown_item, {
                          key: region.uuid,
                          class: _normalizeClass({'world-map__dropdowns-active': region.active }),
                          onClick: ($event: any) => (_ctx.onSelectRegion(region))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createElementVNode("span", _hoisted_11, _toDisplayString(region.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_vit_dropdown, {
                label: _ctx.categoryLabel,
                multiple: "",
                light: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_dropdown_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectCategory(null))),
                    class: _normalizeClass({'world-map__dropdowns-active': _ctx.allCategories })
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.allCategoriesLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
                    return (_openBlock(), _createBlock(_component_dropdown_item, {
                      key: filter.uuid,
                      label: filter.title,
                      class: _normalizeClass({'world-map__dropdowns-active': filter.active }),
                      onClick: ($event: any) => (_ctx.onSelectCategory(filter))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["world-map__dropdowns-checkmark", `world-map__dropdowns-checkmark__${filter.icon}`])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(filter.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["label"])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_search_bar, {
      visible: _ctx.searchVisible,
      onSearch: _ctx.onSearch,
      onResultClicked: _ctx.gotoLocation,
      results: _ctx.isMobile ? [] : _ctx.searchResults,
      placeholder: _ctx.searchPlaceholder
    }, null, 8, ["visible", "onSearch", "onResultClicked", "results", "placeholder"]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.locations.length > 0)
        ? (_openBlock(), _createBlock(_component_google_map, {
            key: 0,
            zoom: _ctx.zoom,
            onMapZoom: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom = $event)),
            center: _ctx.position,
            onMapCenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.position = $event)),
            "zoom-to-bounds": true,
            large: "",
            "api-key": _ctx.apiKey,
            markers: _ctx.locations,
            onMarkerClick: _ctx.onMarkerClick,
            ref: "googlemap"
          }, null, 8, ["zoom", "center", "api-key", "markers", "onMarkerClick"]))
        : _createCommentVNode("", true),
      (_ctx.selectedLocation && _ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(`world-map__info-box world-map__info-box--${_ctx.selectedLocation.category.icon}`)
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedLocation.location.title), 1),
                _createVNode(_component_icon, {
                  name: "icn-cross",
                  class: "world-map__info-box-name-icon",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedLocation = null))
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.detailed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.selectedLocation.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.selectedLocation.description), 1))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLocation.optional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.selectedLocation.optional), 1))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLocation.addressLine1 || _ctx.selectedLocation.addressLine2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.selectedLocation.addressLine1), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.selectedLocation.addressLine2), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.selectedLocation.cityZipCode), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLocation.phone || _ctx.selectedLocation.fax)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (_ctx.selectedLocation.phone)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "button button--linkover",
                                  href: `tel:${_ctx.selectedLocation.phone}`
                                }, " T: " + _toDisplayString(_ctx.selectedLocation.phone), 9, _hoisted_23))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLocation.fax)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, " F: " + _toDisplayString(_ctx.selectedLocation.fax), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLocation.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("a", {
                              class: "button button--link",
                              href: `mailto:${_ctx.selectedLocation.email}`
                            }, "Email", 8, _hoisted_26)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedLocation.link && _ctx.selectedLocation.link.url && _ctx.selectedLocation.link.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("a", {
                              class: "button button--link",
                              href: _ctx.selectedLocation.link.url,
                              target: _ctx.selectedLocation.link.target
                            }, _toDisplayString(_ctx.selectedLocation.link.title), 9, _hoisted_28)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.selectedLocation.description), 1))
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocations, (location) => {
        return (_openBlock(), _createElementBlock("div", {
          key: location.uuid
        }, [
          (location.isRegionChanged && location.regionTitle)
            ? (_openBlock(), _createElementBlock("div", {
                class: "world-map__locations-region",
                key: location.regionId
              }, _toDisplayString(location.regionTitle), 1))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_component_vit_accordion, {
            key: location.uuid,
            title: location.location.title
          }, {
            toggle: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["world-map__category-marker", `world-map__category-marker__${location.icon}`])
              }, _toDisplayString(location.location.title), 3)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["world-map__info-box-description world-map__info-box-description-dropdown", `world-map__info-box-description--${location.icon}`])
              }, [
                (_ctx.detailed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(location.country), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(location.description), 1),
                      (location.optional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(location.optional), 1))
                        : _createCommentVNode("", true),
                      (location.addressLine1 || location.addressLine2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", null, _toDisplayString(location.addressLine1), 1),
                            _createElementVNode("div", null, _toDisplayString(location.addressLine2), 1),
                            _createElementVNode("div", null, _toDisplayString(location.cityZipCode), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (location.phone || location.fax)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            (location.phone)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "button button--linkover",
                                  href: `tel:${location.phone}`
                                }, "T: " + _toDisplayString(location.phone), 9, _hoisted_36))
                              : _createCommentVNode("", true),
                            (location.fax)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, " F: " + _toDisplayString(location.fax), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (location.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("a", {
                              class: "button button--link",
                              href: `mailto:${location.email}`
                            }, "Email", 8, _hoisted_39)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(location.country), 1),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(location.description), 1)
                    ], 64))
              ], 2)
            ]),
            _: 2
          }, 1032, ["title"]))
        ]))
      }), 128))
    ])
  ]))
}